import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
	const { pathname } = useLocation();

	// biome-ignore lint/correctness/useExhaustiveDependencies: pathname jest wyzwalaczem — scroll do góry przy każdej zmianie ścieżki
	useEffect(() => {
		const content = document.getElementById("content");
		if (content) {
			content.scrollTo(0, 0);
		}
	}, [pathname]);

	return null;
};
